import { range } from 'ramda'
import React from 'react'

import { Col, Grid } from '../structure/Grid'
import { HOUR_HEIGHT } from './_helpers/conflict'
import { Relative } from '../helpers/Position'
import { useCalendar } from './CalendarHandler'
import HourlyEvent from './HourlyEvent'
import HourlyPlaceholder from './HourlyPlaceholder'
import Line from '../helpers/Line'
import Text from '../presentation/Text'

const HOURS = range(0, 24)

const DayView = () => {
  const { perspective, events, handleSelectEmptyTime, onSelectEvent } = useCalendar()
  if (perspective !== 'day') return false

  return (
    <>
      {HOURS.map(hour => (
        <div key={hour}>
          <Line />
          <Grid>
            <Col width="5%" align="center" justify="center" direction="row">
              <Line vertical />
              <Col flex={1}>
                <Text align="center">{hour}:00</Text>
              </Col>
              <Line vertical />
            </Col>
            <Col width="95%" direction="row">
              <Col flex={1} height={HOUR_HEIGHT} onClick={() => handleSelectEmptyTime(hour)}>
                <HourlyPlaceholder />
                <Relative zIndex={0}>
                  {events.map(event => (
                    <HourlyEvent key={event.id} event={event} hour={hour} onClick={() => onSelectEvent(event)} />
                  ))}
                </Relative>
              </Col>
              <Line vertical />
            </Col>
          </Grid>
          <Line />
        </div>
      ))}
    </>
  )
}

export default DayView
